(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7261,3129,958,3341],{

/***/ 40286:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ BadgeGroup_BadgeGroup; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js + 1 modules
var Badge = __webpack_require__(68113);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BadgeGroup/BadgeGroup.jsx




var BadgeGroup = function(param) {
    var product = param.product, className = param.className, style = param.style, cardType = param.cardType;
    var ref;
    var isUnavailable = !(product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.itemsAvailable);
    if (!product) return "";
    var badge = {
        type: undefined,
        label: undefined
    };
    if (cardType !== "informative" && isUnavailable) badge = {
        type: "stockout",
        label: "Agotado"
    };
    else if (product.isGift) badge = {
        type: "initial",
        label: "Regalo"
    };
    else if ((product === null || product === void 0 ? void 0 : product.badgePromotion) && cardType !== "informative") badge = {
        type: "initial",
        label: product.badgePromotion
    };
    else if ((product === null || product === void 0 ? void 0 : product.badgePromotion) && (cardType === "catalog" || cardType !== "informative" && product.productsDiscounted > 0)) badge = {
        type: "initial",
        label: product.badgePromotion
    };
    if (!badge.label) return "";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
        className: classnames_default()("absolute top-0 left-0 z-10", className),
        style: style,
        type: badge.type,
        children: badge.label
    });
};
BadgeGroup.propTypes = {
    product: prop_types.object,
    style: prop_types.object,
    className: prop_types.string,
    cardType: prop_types.string
};
/* harmony default export */ var BadgeGroup_BadgeGroup = (BadgeGroup);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/BadgeGroup/index.js



/***/ }),

/***/ 20958:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Caption_Caption; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Caption/Caption.jsx




var Caption = function(param) {
    var className = param.className, classNameImg = param.classNameImg, icon = param.icon, iconAlt = param.iconAlt, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
        className: classnames_default()(className, "mb-0 flex items-center text-left text-caption"),
        children: [
            typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: icon,
                alt: iconAlt,
                className: classnames_default()(classNameImg, "mr-1")
            }) : icon,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            })
        ]
    });
};
Caption.propTypes = {
    className: prop_types.string,
    iconClassName: prop_types.string,
    classNameImg: prop_types.string,
    icon: prop_types.oneOfType([
        prop_types.string,
        prop_types.node
    ]),
    iconAlt: prop_types.string,
    children: prop_types.oneOfType([
        prop_types.string,
        prop_types.object
    ]).isRequired
};
Caption.defaultProps = {
    iconAlt: "info",
    classNameImg: "w-6 h-6"
};
/* harmony default export */ var Caption_Caption = (Caption);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Caption/index.js



/***/ }),

/***/ 69654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCardBody_ProductCardBody; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/index.js + 2 modules
var Rating = __webpack_require__(50952);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/Tooltip/index.js
var Tooltip = __webpack_require__(63129);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Product/ProductPriceForQuantity.jsx
var ProductPriceForQuantity = __webpack_require__(29832);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardCaption/index.js + 1 modules
var ProductCardCaption = __webpack_require__(23341);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardBody/ProductCardBody.jsx









var ProductBrandAndName = function(param) {
    var product = param.product, cardType = param.cardType, context = param.context;
    var brandClassNames = classnames_default()("mb-1 lg:mb-2 text-left text-ui-gray-500 text-caption font-body font-body-regular");
    var nameClassNames = classnames_default()("mb-1 sm:mb-0 text-left text-ui-gray-900 text-small font-body font-body-bold overflow-hidden grow", {
        "h-8.5": cardType === "catalog"
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col",
            children: [
                product.brand ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: brandClassNames,
                    children: product.brand
                }) : !product.brand && cardType === "catalog" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "h-6"
                }) : "",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip["default"], {
                    uniqueId: "product-full-name",
                    showOnHover: true,
                    placement: "bottom",
                    tooltipContent: product.name.length > 40 && context !== "cart" && context !== "checkout" && context !== "pos" && context !== "success" ? product.name : null,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: nameClassNames,
                        children: product.name.length > 40 && context !== "cart" && context !== "checkout" && context !== "pos" && context !== "success" ? product.name.substring(0, 40) + "..." : product.name
                    })
                })
            ]
        })
    });
};
var ProductCardBody = function(param) {
    var product = param.product, showRatings = param.showRatings, className = param.className, styles = param.styles, context = param.context, cardType = param.cardType, hideDiscounts = param.hideDiscounts;
    var cardBodyClass = classnames_default()("w-full flex flex-col", className);
    var showCaption = cardType === "informative" && (context === "checkout" || context === "success" || context === "profileOrder");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: cardBodyClass,
            style: styles,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductBrandAndName, {
                    product: product,
                    context: context,
                    cardType: cardType
                }),
                showRatings && /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
                    rating: product.reviewAverage || 0,
                    review: product.reviewCount || 0
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductPriceForQuantity/* default */.Z, {
                    pricesWrapperClassName: "flex-col",
                    discountsWrapperClassName: "mb-0.5",
                    context: context,
                    product: product,
                    hideDiscounts: hideDiscounts
                }),
                !(0,src/* get_ */.jR)(product, [
                    "isGift"
                ]) && showCaption && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "mt-2 hidden lg:block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCaption["default"], {
                        promotion: product.firstApplicableRule,
                        appliedBenefits: product.appliedBenefits
                    })
                })
            ]
        })
    });
};
ProductCardBody.defaultProps = {
    showRatings: false,
    hideDiscounts: false
};
ProductCardBody.propTypes = {
    product: prop_types.object,
    className: prop_types.string,
    styles: prop_types.object,
    showRatings: prop_types.bool,
    context: prop_types.string,
    cardType: prop_types.string,
    hideDiscounts: prop_types.bool
};
/* harmony default export */ var ProductCardBody_ProductCardBody = (ProductCardBody);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardBody/index.js



/***/ }),

/***/ 23341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ ProductCardCaption_ProductCardCaption; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/use-media/lib/index.js
var lib = __webpack_require__(81145);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/CheckIcon.js
var CheckIcon = __webpack_require__(14718);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/InformationPromoIcon.js
var InformationPromoIcon = __webpack_require__(2506);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Caption/index.js + 1 modules
var Caption = __webpack_require__(20958);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardCaption/ProductCardCaption.jsx








var Link = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 35384));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35384)
            ];
        }
    },
    ssr: false
});
var Tooltip = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1607), __webpack_require__.e(3129)]).then(__webpack_require__.bind(__webpack_require__, 63129));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63129)
            ];
        }
    },
    ssr: false
});
var FullModal = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4521).then(__webpack_require__.bind(__webpack_require__, 84521));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84521)
            ];
        }
    },
    ssr: false
});
var TooltipDiscountContent = function(param) {
    var tooltipContent = param.tooltipContent, isModal = param.isModal;
    return tooltipContent && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "text-left",
        children: tooltipContent.map(function(i, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                className: !isModal ? "text-caption" : "",
                children: isModal ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                    className: "my-1 mr-1 h-4 w-4 rounded-full bg-ui-success fill-white stroke-white stroke-2 p-1"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: i
                })
            }, index);
        })
    });
};
var DiscountCaption = function(param) {
    var discounts = param.discounts, isMobile = param.isMobile, context = param.context;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    if (!discounts) return "";
    var discountsLength = discounts.length;
    var discountsToShow = context === "cart" ? discounts : discounts.slice(0, 1);
    if (!isMobile && discountsLength >= 3 && context === "cart") discountsToShow = discounts.slice(1, 3);
    else if (isMobile && discountsLength >= 2) discountsToShow = [];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "mt-1 flex w-full items-center justify-start gap-x-2",
        children: [
            discountsToShow.map(function(discount, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption["default"], {
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                        className: "my-1 mr-1 h-4 w-4 rounded-full bg-ui-success fill-white stroke-white stroke-2 p-1"
                    }),
                    children: discount
                }, index);
            }),
            discountsLength >= 3 && !isMobile || discountsLength >= 2 && !isMobile && context !== "cart" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip, {
                uniqueId: "tooltip-discounts",
                anchorClassName: "min-w-max p-1 text-caption font-body font-body-bold underline truncate",
                placement: "right",
                showOnHover: true,
                tooltipContent: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipDiscountContent, {
                    tooltipContent: discounts
                }),
                children: "M\xe1s promos"
            }) : discountsLength > 1 && isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link, {
                        className: "text-caption text-black",
                        onClick: function() {
                            return setShowModal(true);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckIcon/* default */.Z, {
                                className: "my-1 mr-1 h-4 w-4 rounded-full bg-ui-success fill-white stroke-white stroke-2 p-1"
                            }),
                            "Ver descuentos aplicados"
                        ]
                    }),
                    showModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullModal, {
                        isOpen: showModal,
                        onClose: function() {
                            return setShowModal(false);
                        },
                        title: "Descuentos aplicados",
                        headerBackgroundColor: "bg-brand-primary-300",
                        headerShadow: true,
                        overlayClassName: "h-screen bg-ui-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipDiscountContent, {
                            tooltipContent: discounts,
                            isModal: true
                        })
                    })
                ]
            })
        ]
    });
};
var ProductCardCaption = function(param) {
    var availability = param.availability, promotion = param.promotion, appliedBenefits = param.appliedBenefits, context = param.context;
    var isMobile = (0,lib/* default */.ZP)({
        maxWidth: 640
    });
    var productIsUnavailable = availability && !availability.availableOnZipCode && (0,src/* get_ */.jR)(availability, [
        "status"
    ], "") === "unavailable";
    if (productIsUnavailable) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption["default"], {
        className: "mt-1.5",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationIcon, {
            className: "h-5 w-5 text-brand-tertiary-700"
        }),
        children: "Producto no disponible en tu ubicaci\xf3n"
    });
    else if (promotion && promotion.title) return /*#__PURE__*/ (0,jsx_runtime.jsx)(Caption["default"], {
        className: "mt-1.5",
        icon: promotion.icon || /*#__PURE__*/ (0,jsx_runtime.jsx)(InformationPromoIcon/* default */.Z, {
            className: "h-5 w-5 text-ui-success"
        }),
        children: promotion.title
    });
    else if (appliedBenefits && appliedBenefits.length) {
        var discountsApplied = appliedBenefits.map(function(d) {
            return d.title;
        });
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(DiscountCaption, {
            discounts: discountsApplied,
            isMobile: isMobile,
            context: context
        });
    }
    return "";
};
ProductCardCaption.defaultProps = {
    appliedBenefits: []
};
ProductCardCaption.propTypes = {
    availability: prop_types.shape({
        availableOnZipCode: prop_types.bool,
        status: prop_types.string
    }),
    promotion: prop_types.shape({
        title: prop_types.string,
        icon: prop_types.string
    }),
    appliedBenefits: prop_types.array,
    context: prop_types.string
};
/* harmony default export */ var ProductCardCaption_ProductCardCaption = (/*#__PURE__*/react.memo(ProductCardCaption));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardCaption/index.js



/***/ }),

/***/ 11962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCardImage_ProductCardImage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Image/index.js
var Image = __webpack_require__(4740);
// EXTERNAL MODULE: ../../packages/designkit/src/assets/icon-camera.svg
var icon_camera = __webpack_require__(43987);
var icon_camera_default = /*#__PURE__*/__webpack_require__.n(icon_camera);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardImage/ProductCardImage.jsx






var BLUR_DATA_URL = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcWg8AAc8BJpg2zxQAAAAASUVORK5CYII=";
var GIFT_IMAGE = "https://us-central1-yema-cdn.cloudfunctions.net/cdn/api/v1/yema-plm/images/view/assets/regalito-yema_ec2e304b-bf69-4226-a853-65b2237e6468";
var ProductCardImage = function(param) {
    var product = param.product, style = param.style, className = param.className, imageClassName = param.imageClassName, size = param.size, fadeIfUnavailable = param.fadeIfUnavailable, noImageText = param.noImageText;
    var ref, ref1, ref2;
    var shouldFadeImage = fadeIfUnavailable && ((product === null || product === void 0 ? void 0 : (ref = product.availability) === null || ref === void 0 ? void 0 : ref.status) === "stock-out" || (product === null || product === void 0 ? void 0 : (ref1 = product.availability) === null || ref1 === void 0 ? void 0 : ref1.status) === "unavailable");
    var mainImage = ((ref2 = product.bundle) === null || ref2 === void 0 ? void 0 : ref2.mainImage) || product.mainImage;
    var noImage = Boolean(!product.isGift && !mainImage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("relative flex", className),
        style: style,
        children: noImage ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "absolute flex h-full w-full flex-col justify-center",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: (icon_camera_default()),
                    alt: "Icono de c\xe1mara",
                    width: size === "xs" ? 50 : 140,
                    height: size === "xs" ? 50 : 140,
                    placeholder: "blur",
                    blurDataURL: BLUR_DATA_URL
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "mt-2 px-1 text-center font-body font-body-medium sm:mt-3",
                    style: {
                        fontSize: size === "xs" ? "9px" : "11px",
                        lineHeight: size === "xs" ? "10px" : ".8rem"
                    },
                    children: noImageText && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: "Producto en sesi\xf3n de fotos"
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
            layout: "fill",
            objectFit: !mainImage && !product.isGift ? "contain" : "cover",
            objectPosition: "center",
            sizes: "(min-width: 768px) 260px, 108px",
            className: classnames_default()(imageClassName, "absolute top-0 left-0 h-full w-full", {
                "mx-auto h-auto w-1/2": !mainImage && !product.isGift,
                "h-full w-full": mainImage || product.isGift,
                "opacity-40": shouldFadeImage
            }),
            src: product.isGift ? GIFT_IMAGE : mainImage,
            alt: product.mainImageAlt || product.name,
            placeholder: "blur",
            blurDataURL: BLUR_DATA_URL
        })
    });
};
ProductCardImage.defaultProps = {
    noImageText: true
};
ProductCardImage.propTypes = {
    product: prop_types.object,
    fadeIfUnavailable: prop_types.bool,
    size: prop_types.oneOf([
        "xs",
        "small",
        "big"
    ]),
    style: prop_types.object,
    className: prop_types.string,
    imageClassName: prop_types.string,
    cardType: prop_types.string
};
/* harmony default export */ var ProductCardImage_ProductCardImage = (ProductCardImage);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardImage/index.js



/***/ }),

/***/ 61687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ProductCardAction_ProductCardAction; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCardAction/ProductCardAction.jsx





var ProductCardAction = function(param) {
    var className = param.className, product = param.product, redirectToProductPage = param.redirectToProductPage, onClickOnCard = param.onClickOnCard, children = param.children;
    var onCardClick = function(e) {
        if (onClickOnCard && typeof onClickOnCard === "function") onClickOnCard(e);
    };
    if (!redirectToProductPage) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()("grid-cols-inherit", className),
        children: children
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
        className: classnames_default()("grid-cols-inherit", className),
        underline: false,
        label: product.name,
        href: product.href,
        onClick: onCardClick,
        children: children
    });
};
/* harmony default export */ var ProductCardAction_ProductCardAction = (ProductCardAction);
ProductCardAction.propTypes = {
    className: prop_types.string,
    product: prop_types.object,
    redirectToProductPage: prop_types.bool,
    onClickOnCard: prop_types.func,
    children: prop_types.node
};

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCardAction/index.js



/***/ }),

/***/ 38534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97988);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96247);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63890);
/* harmony import */ var reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34301);







var Tooltip = function(param) {
    var uniqueId = param.uniqueId, anchorClassName = param.anchorClassName, tooltipBgColor = param.tooltipBgColor, arrowFillColor = param.arrowFillColor, placement = param.placement, showOnHover = param.showOnHover, tooltipContent = param.tooltipContent, children = param.children;
    // Prefix is required to target tooltip with CSS selector (see tailwind.scss)
    var id = "aria-tooltip-" + uniqueId;
    var tooltipState = (0,reakit_Tooltip__WEBPACK_IMPORTED_MODULE_3__/* .useTooltipState */ .K)({
        baseId: id,
        padding: 5,
        gutter: 12,
        visible: showOnHover ? undefined : true,
        placement: placement,
        unstable_fixed: true,
        unstable_flip: true
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        tooltipState.place(placement);
    }, [
        tooltipState.place,
        placement
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_4__/* .TooltipReference */ .v, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                as: "div",
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(anchorClassName, {
                    "cursor-pointer": showOnHover
                }),
                children: children
            })),
            tooltipContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_7__/* .Tooltip */ .u, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                baseId: id
            }, tooltipState), {
                visible: showOnHover ? tooltipState.visible : true,
                unstable_portal: false,
                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()(tooltipBgColor, "max-w-sm rounded-sm p-2 text-center text-ui-black", placement === "top" ? "shadow-up" : "shadow-down"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(reakit_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* .TooltipArrow */ .C, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, tooltipState), {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-6 w-6", arrowFillColor)
                    })),
                    typeof tooltipContent === "string" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                            children: tooltipContent
                        })
                    }) : tooltipContent
                ]
            }))
        ]
    });
};
Tooltip.displayName = "Tooltip";
Tooltip.defaultProps = {
    tooltipBgColor: "bg-brand-primary-300",
    arrowFillColor: "fill-brand-primary-300",
    placement: "auto",
    showOnHover: true
};
Tooltip.propTypes = {
    uniqueId: prop_types__WEBPACK_IMPORTED_MODULE_9__.string.isRequired,
    anchorClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipClassName: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    tooltipBgColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    arrowFillColor: prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
    placement: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOf([
        "auto-start",
        "auto",
        "auto-end",
        "top",
        "bottom",
        "left",
        "right", 
    ]),
    showOnHover: prop_types__WEBPACK_IMPORTED_MODULE_9__.bool,
    /** Text to show inside the tooltip */ tooltipContent: prop_types__WEBPACK_IMPORTED_MODULE_9__.oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_9__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_9__.node
    ]),
    /** Tooltip width */ children: prop_types__WEBPACK_IMPORTED_MODULE_9__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 63129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* reexport safe */ _Tooltip__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _Tooltip__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38534);



/***/ }),

/***/ 43987:
/***/ (function(module) {

module.exports = "/_next/static/images/icon-camera-5d664641812d0cecbead936b8866b0c0.svg";

/***/ }),

/***/ 2506:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function InformationPromoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M14.29 21a.805.805 0 01-.637-.314l-9.995-9.995a2.548 2.548 0 01-.653-1.555L3 4.148C3 3.514 3.515 3 4.148 3h4.965a2.538 2.538 0 011.562.639l10.011 10.016a.806.806 0 01-.356 1.43l-4.02 1.226-1.227 4.019a.81.81 0 01-.792.67zM4.149 3.765a.383.383 0 00-.383.383l.005 4.967c.021.378.179.756.443 1.05l10.001 10a.331.331 0 01.045.054.037.037 0 00.027.015c.025 0 .04-.014.043-.033a.34.34 0 01.015-.068l1.295-4.24a.38.38 0 01.254-.253l4.241-1.295a.31.31 0 01.066-.014.043.043 0 00.027-.016.04.04 0 00-.01-.056.335.335 0 01-.05-.042L10.147 4.193a1.732 1.732 0 00-1.05-.428h-4.95z"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M7.207 9.12a1.914 1.914 0 01-1.913-1.912c0-1.055.858-1.913 1.913-1.913 1.055 0 1.913.858 1.913 1.913A1.915 1.915 0 017.207 9.12zm0-3.06a1.149 1.149 0 000 2.295c.633 0 1.147-.515 1.147-1.147 0-.633-.514-1.148-1.147-1.148z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(InformationPromoIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);